import { SmoobuApartment } from "../_modelsTS/Integration";
import { GenericCollectionFactory } from "../_generics";

export const SmoobuStore = GenericCollectionFactory<SmoobuApartment>("SMOOBU-INTEGRATION", "id");